import { useGlobal } from '@/utils/useGlobal';
import EcoNavProduct, { EcoNavProductProps } from 'eco-design/sections/eco-nav-product';
import { useRouter } from 'next/router';
import { productPageUrl } from '../../config/pageConfig';
import { useProductDispatch } from '../../ProductStationProvider';
import styles from './index.module.scss';
import { LangText } from './LangText';

export default function ProductNav({ activeTab, tabCallback }: { activeTab: string; tabCallback?: any }) {
    const router = useRouter();
    const { locale = 'us', pathname } = router;
    const { isMobile } = useGlobal();
    const TextA = LangText[locale] || LangText['us'];
    const thePageUrl = `/${locale}/${productPageUrl}`;
    const isInProductPage = pathname.endsWith(productPageUrl);
    const dispatch = useProductDispatch();

    const currentQueryString = router.asPath.includes('?') ? router.asPath.split('?')[1] : '';

    console.log(currentQueryString);

    const buildUrlWithQuery = (basePath: string) => {
        return currentQueryString ? decodeURIComponent(`${basePath}?${currentQueryString}`) : basePath;
    };

    const buyMap = {
        us: 'https://us.ecoflow.com/products/delta-3-ultra-series-portable-power-station',
        ca: 'https://ca.ecoflow.com/products/delta-3-ultra-series-portable-power-station',
    };
    const dataA: EcoNavProductProps = {
        productItems: [
            {
                value: 'name1',
                label: TextA.product_name,
                // href: thePageUrl,
            },
        ],
        tabItems: [
            {
                value: 'Product',
                label: TextA.tab_product,
                href: isInProductPage ? undefined : buildUrlWithQuery(thePageUrl),
            },
            {
                value: 'Bundles',
                label: 'Bundles',
            },
            {
                value: 'Specs',
                label: TextA.tab_specs,
                // 加上当前的查询参数
                href: buildUrlWithQuery(`${thePageUrl}/specs`),
            },
            {
                value: 'Compatibility',
                label: 'Compatibility',
                href: buildUrlWithQuery(`${thePageUrl}/compatibility`),
            },
            {
                value: 'Support',
                label: TextA.tab_support,
                href: buildUrlWithQuery(`${thePageUrl}/support`),
            },

            // {
            //     value: 'Media',
            //     label: TextA.tab_media,
            //     href: `${thePageUrl}/media`,
            // },
        ],
        buyItems: [
            {
                value: 'Buy',
                label: TextA.btn_buy,
                href: buyMap[locale as keyof typeof buyMap],
                // href: isInProductPage ? undefined : `${thePageUrl}?tab=Bundles`,
            },
        ],
        theme: 'black',
    };
    const tabChange = (item: any, index: number) => {
        // dispatch({
        //     type: 'changeProductTabActive',
        //     payload: item.value,
        // });
        // 切换时划回顶部
        setTimeout(() => {
            const headerElem = document.querySelector('.ecoflow-frame-header');
            window.scrollTo({
                top: headerElem?.clientHeight,
                behavior: 'smooth', // 可选，平滑滚动
            });
        }, 100);

        if (tabCallback) {
            tabCallback(item.value);
        }
    };
    const handleBuyChange = (item: any, index: number) => {
        // dispatch({
        //     type: 'changeProductTabActive',
        //     payload: item.value,
        // });
        // if (tabCallback) {
        //     tabCallback('Bundles');
        // }
    };

    return <EcoNavProduct {...dataA} defaultTabActiveKey={activeTab} onTabChange={tabChange} onBuyChange={handleBuyChange} theme={'black'} />;
}
